import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-MF",
  "use": "icon-MF-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-MF\"><path d=\"M507.904 913.92a354.816 354.816 0 1 1 354.816-354.816 354.816 354.816 0 0 1-354.816 354.816z m0-639.488a285.184 285.184 0 1 0 285.184 285.184 285.184 285.184 0 0 0-285.184-285.184z\" fill=\"#999999\" p-id=\"1476\" /><path d=\"M355.328 712.704V424.448h70.144l82.432 190.976 82.432-190.976h70.144v288.256h-66.56v-138.24l-59.904 138.24H481.792l-60.416-138.24v138.24H355.328z\" fill=\"#999999\" p-id=\"1477\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/MF.svg
// module id = VFBT
// module chunks = 55